// Date, time
export const TIME_FORMAT = "HH:mm:ss";
export const TIME_NO_SECONDS_FORMAT = "HH:mm";
export const DATE_TIME_FORMAT = `dd MMM yyyy, ${TIME_FORMAT}`;
export const DATE_FORMAT = `dd MMM, yyyy`;
export const DATE_TIME_NO_SECONDS_FORMAT = `dd MMM yyyy, ${TIME_NO_SECONDS_FORMAT}`;
export const DATE_TIME_NO_SECONDS_COMPACT_FORMAT = `dd MMM yy, ${TIME_NO_SECONDS_FORMAT}`;
export const DATE_TIME_NO_YEAR_FORMAT = `dd MMM ${TIME_FORMAT}`;
export const DAY_MONTH_FORMAT = `dd-MM`;
export const MONTH_YEAR_FORMAT = `MMM yyyy`;